<!-- 
	This is the tables page, it uses the dashboard layout in: 
	"./layouts/Dashboard.vue" .
 -->

 <template>
  <div>
    <!-- Authors Table -->
    <a-row :gutter="24" type="flex">
      <!-- Authors Table Column -->
      <a-col :span="24" class="mb-24">
        <!-- Authors Table Card -->
        <CardAuthorTable
          :data="table1Data"
          :columns="table1Columns"
          @getUsers="getUsers"
        ></CardAuthorTable>
        <!-- / Authors Table Card -->
      </a-col>
      <!-- / Authors Table Column -->
    </a-row>
    <!-- / Authors Table -->

    <!-- Projects Table -->
    <!-- <a-row :gutter="24" type="flex">

			<a-col :span="24" class="mb-24">
				<CardProjectTable2
					:data="table2Data"
					:columns="table2Columns"
				></CardProjectTable2>

			</a-col>
		</a-row> -->
    <!-- / Projects Table -->
  </div>
</template>

<script>
import { userlist } from "@/api/user";
// "Authors" table component.
import CardAuthorTable from "./components/CardAuthorTable";

// "Projects" table component.
import CardProjectTable2 from "./components/CardProjectTable2";

// "Authors" table list of columns and their properties.
const table1Columns = [
  {
    title: "账号",
    dataIndex: "username",
    scopedSlots: { customRender: "username" },
    width: 200,
  },
  {
    title: "域名",
    dataIndex: "website",
    scopedSlots: { customRender: "website" },
    width: 600,
  },
  {
    title: "斗篷状态",
    dataIndex: "cloak",
    scopedSlots: { customRender: "cloak" },
    width: 100,
  },
  {
    title: "到期时间",
    dataIndex: "expiry_time",
    scopedSlots: { customRender: "expiry_time" },
  },
  {
    title: "操作",
    scopedSlots: { customRender: "editBtn" },
    width: 50,
  },
];

// "Projects" table list of columns and their properties.
const table2Columns = [
  {
    title: "COMPANIES",
    dataIndex: "company",
    scopedSlots: { customRender: "company" },
    width: 300,
  },
  {
    title: "BUDGET",
    dataIndex: "budget",
    class: "font-semibold text-muted",
  },
  {
    title: "STATUS",
    dataIndex: "status",
    class: "font-semibold text-muted text-sm",
  },
  {
    title: "COMPLETION",
    scopedSlots: { customRender: "completion" },
    dataIndex: "completion",
  },
  {
    title: "",
    scopedSlots: { customRender: "editBtn" },
    width: 50,
  },
];

// "Projects" table list of rows and their properties.
const table2Data = [
  {
    key: "1",
    company: {
      name: "Spotify Version",
      logo: "images/logos/logo-spotify.svg",
    },
    status: "working",
    budget: "$14,000",
    completion: 60,
  },
  {
    key: "2",
    company: {
      name: "Progress Track",
      logo: "images/logos/logo-atlassian.svg",
    },
    status: "working",
    budget: "$3,000",
    completion: 10,
  },
  {
    key: "3",
    company: {
      name: "Jira Platform Errors",
      logo: "images/logos/logo-slack.svg",
    },
    status: "done",
    budget: "Not Set",
    completion: {
      status: "success",
      value: 100,
    },
  },
  {
    key: "4",
    company: {
      name: "Launch new Mobile App",
      logo: "images/logos/logo-spotify.svg",
    },
    status: "canceled",
    budget: "$20,600",
    completion: {
      status: "exception",
      value: 50,
    },
  },
  {
    key: "5",
    company: {
      name: "Web Dev",
      logo: "images/logos/logo-webdev.svg",
    },
    status: "working",
    budget: "$4,000",
    completion: 80,
  },
  {
    key: "6",
    company: {
      name: "Redesign Online Store",
      logo: "images/logos/logo-invision.svg",
    },
    status: "canceled",
    budget: "$2,000",
    completion: {
      status: "exception",
      value: 0,
    },
  },
];

export default {
  components: {
    CardAuthorTable,
    CardProjectTable2,
  },
  data() {
    return {
      // Associating "Authors" table data with its corresponding property.
      table1Data: [],

      // Associating "Authors" table columns with its corresponding property.
      table1Columns: table1Columns,

      // Associating "Projects" table data with its corresponding property.
      table2Data: table2Data,

      // Associating "Projects" table columns with its corresponding property.
      table2Columns: table2Columns,
    };
  },
  methods: {
    getUsers() {
      userlist().then((res) => {
        this.table1Data = res.data.map((user) => {
          if (Array.isArray(user.website)) {
            user.website = user.website.join(",");
          }
          return user;
        });
      });
    },
  },
  mounted() {
    this.getUsers();
  },
};
</script>

<style lang="scss">
</style>